var WebFont = require('webfontloader');
require('./../drawer/drawer.js');
require('./../scrollspy/scrollspy.js');

WebFont.load({
    classes: true,
    google: {
        families: ['Open Sans:400,600,700:latin-ext']
    },
    custom: {
        families: ['TeXGyreAdventor:n4,n7'],
        urls: [
            '//static.ed.edmunds-media.com/unversioned/ng/fonts/tex-gyre-adventor-v2.0/style.css'
        ]
    },
    active: function() {
        $(window.document).trigger('webfont.loaded');
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/jslib-edm-bootstrap/src/theme/groundwork.js
// module id = 283
// module chunks = 18